import React from 'react';
import Search from 'schema-form/elements/advance-search';
import { searchFormSchema, searchRecapFormSchema } from './advance';
import { t1 } from 'translate';
import codes from 'components/admin/group/schema/elements/filterset/filter/schema/codes';
import mails from 'components/admin/group/schema/elements/filterset/filter/schema/mails';
import names from 'components/admin/group/schema/elements/filterset/filter/schema/names';
import phones from 'components/admin/group/schema/elements/filterset/filter/schema/phones';
import SearchFormLayout from './SearchFormLayout';
import get from 'lodash.get';

const defaultFields = ['codes', 'mails', 'names', 'phones', 'text'];

const schema = (formid, values, localStep, xpath, props) => {
  const { defaultValues } = props;
  return {
    codes: codes(false, {
      rows: 2,
    }),
    mails: mails(false, {
      rows: 2,
    }),
    names: names(false, {
      rows: 2,
    }),
    phones: phones(false, {
      rows: 2,
    }),
    text: {
      type: Search,
      schema: searchFormSchema({ ...props, skipFields: defaultFields }),
      recapSchema: searchRecapFormSchema({
        ...props,
        skipFields: defaultFields,
      }),
      labelText: t1('user_name,_email,_id_or_code...'),
      defaultValues,
    },
    licensing_status: {
      type: 'radio',
      floatingLabelText: t1('license_licensing_status'),
      options: [
        {
          value: 'licensed',
          label: 'Đã được cấp',
        },
        {
          value: 'unlicensed',
          label: 'Chưa được cấp',
        },
      ],
      defaultValue: 'licensed',
      inline: true,
    },
    license_in_active: {
      type: 'multiCheckbox',
      floatingLabelText: t1('user_license_status'),
      options: [
        {
          value: 'active',
          label: 'Đang hoạt động',
        },
        {
          value: 'inactive',
          label: 'Hết hạn',
        },
        {
          value: 'no_license',
          label: 'Chưa có giấy phép',
        },
      ],
      inline: true,
    },
  };
};

const ui = (step, values) => {
  const fields = defaultFields;

  if (get(values, 'licensing_status')) {
    fields.push('license_in_active');
  }

  return [
    {
      id: 'id',
      fields,
    },
  ];
};

export default {
  schema,
  ui,
  layout: { component: SearchFormLayout, freestyle: 1 },
  isAdvanceSearch: true,
};
